import { mapState } from 'vuex';
import {
  SWITCH_SERVER,
  UPDATE_ROLE_LIST,
  UPDATE_PC_SERVER_ID,
  UPDATE_LOADING,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_HAS_SELECT_PRODUCT,
  SWITCH_ROLE,
  UPDATE_ROLE_NAME,
  GET_ROLE_LIST,
  UPDATE_PRODUCT_LIST,
  GET_PRODUCT_LIST,
  UPDATE_PRODUCT_TYPES,
  GET_SERVER_LIST
} from '@store/officialTopupNew';
import {
  UPDATE_UID,
  UPDATE_UID_TOKEN_LOGIN_STATUS,
  UPDATE_UID_LOGIN_STATUS,
  UID_LOGIN,
  LOGOUT,
  UPDATE_THIRD_LIST,
  FB_LOGIN_HREF,
  TWI_LOGIN_HREF,
  LINE_LOGIN_HREF,
  GOOGLE_PLAY_LOGIN_HREF,
  VK_LOGIN_HREF,
  APPLE_LOGIN_HREF,
  UPDATE_IS_JP_UID_LOGIN,
  UPDATE_IS_LOGIN_POPUP,
  UPDATE_IS_SELECT_ROLE_POPUP,
  UPDATE_SWITCH_ROLE_PANEL
} from '@store/officialTopupNew/login';
import globalConfig from '@utiles/officialStore/globalConfig';
import { initViewport } from '@utiles/officialStore/index';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
import { popupType, showPopup } from '@plugins/biPoint/_configWebstoreV35';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { trackStagePoint } from '@utiles/officialTopupNew/speedPoint';
const MAIN_HOST = globalConfig.getMainHost();
export const mapServerIdBypcServerId = (pcServerId, serverList) => {
  let serverId = '';
  try {
    for (let item of serverList) {
      if (item.SID === pcServerId) {
        serverId = item.ID;
        break;
      }
    }
  } catch (e) {
    serverId = '';
  }
  return serverId;
};
export default {
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin,
      isJpUidLogin: state => state.login.isJpUidLogin,
      isUidLogin: state => state.login.isUidLogin,
      isUidTokenLogin: state => state.login.isUidTokenLogin,
      isUidTypeAndHideVipCoupon: state => state.login.isUidTypeAndHideVipCoupon,
      letter: state => state.letter,
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      uid: state => state.login.uid,
      loginAccount: state => state.login.loginAccount,
      displayName: state => state.login.displayName,
      isLoginPopup: state => state.login.isLoginPopup,
      thirdList: state => state.login.thirdList,
      isSelectRolePopup: state => state.login.isSelectRolePopup,
      switchRolePanel: state => state.login.switchRolePanel,
      roleList: state => state.roleList,
      showLoginType: state => state.login.showLoginType,

      isFollowGameLogin: state => state.page.isFollowGameLogin,
      defaultLogin: state => state.page.defaultLogin,
      loginType: state => state.page.loginType,
      isJudgeLoginEnd: state => state.login.isJudgeLoginEnd
    }),
    serverId: {
      get() {
        return this.$store.state.serverId || 0;
      },
      set(id) {
        this.$store.commit(SWITCH_SERVER, id);
        this.$store.commit(UPDATE_PC_SERVER_ID, this.getCurSid(id));
      }
    },
    roleId: {
      get() {
        return this.serverId === 0 ? -1 : this.$store.state.roleId || -1;
      },
      set(id) {
        this.$store.commit(SWITCH_ROLE, id);
        this.$store.commit(UPDATE_ROLE_NAME, this.getCurRoleName(id));
      }
    },
    getCurLastedServerName() {
      let res = '';
      if (!this.serverList || this.lastedGame != this.gameId) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == this.lastedServerId) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    },
    loginHref() {
      const tips = `javascript:alert('${this.letter.unLink}')`;
      let realForwardUrl = window.location.href;

      // 2017.1.17
      // web_source：用来标记从平台登录页登录注册的数据，并在后端进行过滤（避免非h5游戏产生web端新用户数据）
      return {
        facebook:
          FB_LOGIN_HREF +
          this.$store.state.lang +
          `&game_id=${this.gameId
          }&web_source=platform&timeZone=${encodeURIComponent(
            globalConfig.getTimeZone()
          )}&forward=${encodeURIComponent(
            getGlobalGetGotoLink({
              link: globalConfig.hrefAddParam(
                realForwardUrl,
                'gameId',
                this.gameId
              )
            })
          )}` || tips,
        twitter:
          TWI_LOGIN_HREF +
          this.$store.state.lang +
          `&game_id=${this.gameId
          }&web_source=platform&timeZone=${encodeURIComponent(
            globalConfig.getTimeZone()
          )}&forward=${encodeURIComponent(
            getGlobalGetGotoLink({
              link: globalConfig.hrefAddParam(
                realForwardUrl,
                'gameId',
                this.gameId
              )
            })
          )}` || tips,
        line:
          LINE_LOGIN_HREF +
          this.$store.state.lang +
          `&game_id=${this.gameId
          }&web_source=platform&timeZone=${encodeURIComponent(
            globalConfig.getTimeZone()
          )}&forward=${encodeURIComponent(
            getGlobalGetGotoLink({
              link: globalConfig.hrefAddParam(
                realForwardUrl,
                'gameId',
                this.gameId
              )
            })
          )}` || tips,
        naver: tips,
        googleplay:
          GOOGLE_PLAY_LOGIN_HREF +
          this.$store.state.lang +
          `&game_id=${this.gameId
          }&web_source=platform&timeZone=${encodeURIComponent(
            globalConfig.getTimeZone()
          )}&forward=${encodeURIComponent(
            getGlobalGetGotoLink({
              link: globalConfig.hrefAddParam(
                realForwardUrl,
                'gameId',
                this.gameId
              )
            })
          )}` || tips,
        vk:
          VK_LOGIN_HREF +
          this.$store.state.lang +
          `&game_id=${this.gameId
          }&web_source=platform&timeZone=${encodeURIComponent(
            globalConfig.getTimeZone()
          )}&forward=${encodeURIComponent(
            getGlobalGetGotoLink({
              link: globalConfig.hrefAddParam(
                realForwardUrl,
                'gameId',
                this.gameId
              )
            })
          )}` || tips,
        apple:
          APPLE_LOGIN_HREF +
          this.$store.state.lang +
          `&game_id=${this.gameId
          }&web_source=platform&timeZone=${encodeURIComponent(
            globalConfig.getTimeZone()
          )}&forward=${encodeURIComponent(
            getGlobalGetGotoLink({
              link: globalConfig.hrefAddParam(
                realForwardUrl,
                'gameId',
                this.gameId
              )
            })
          )}` || tips
      };
    }
  },
  methods: {
    resetStatus() {
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
    },
    handleUidLogin() {
      this.$store.commit(UPDATE_UID_LOGIN_STATUS, true);
    },
    handleUidTokenLogin() {
      this.$store.commit(UPDATE_UID_TOKEN_LOGIN_STATUS, true);
    },
    login() {
      this.doLogin({
        gameId: this.gameId,
        serverId: this.serverId,
        roleId: this.roleId,
        pcServerId: this.pcServerId
      });
    },
    doLogin({ gameId, serverId, roleId, pcServerId }) {
      const p = globalConfig.getHrefParam('p');
      const params = {
        gameId: gameId ? `gameId=${gameId}` : '',
        serverId:
          serverId != undefined && serverId !== 0
            ? `server_id=${serverId}`
            : '',
        pcServerId: pcServerId ? `serverId=${pcServerId}` : '',
        roleId: roleId != undefined && roleId !== -1 ? `roleId=${roleId}` : '',
        hrefSearch: window.location.search.substring(1) || ''
      };
      const queryString = Object.values(params).filter(Boolean).join('&');
      const url = `https://pay.${MAIN_HOST}/platform/officialTopupNew.html${queryString ? `?${queryString}` : ''
        }`;
      const forward = encodeURIComponent(getGlobalGetGotoLink({ link: url }));
      const realHref = `https://pay.${MAIN_HOST}/platform/login.html?${params.gameId ? params.gameId + '&' : ''
        }${p ? `p=${p}&` : ''}forward=${forward}`;
      window.location.href = realHref;
    },
    goLogOut() {
      this.$store.dispatch(LOGOUT).then(() => {
        window.location.reload();
      });
    },
    handleSwitchWay() {
      if (this.isLogin) {
        this.goLogOut();
      } else {
        this.$store.commit(UPDATE_UID_LOGIN_STATUS, false);
      }
    },
    doUidLogin() {
      if (!this.uid) {
        alert(this.letter.storeInputId);
        return;
      }
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(UID_LOGIN, {
          uid: this.uid,
          gameId: this.gameId,
          language: this.lang
        })
        .then(({ result }) => {
          if (result) {
            this.$store.commit(SWITCH_SERVER, 0);
            this.$store.commit(UPDATE_PC_SERVER_ID, 0);
            this.$store.commit(UPDATE_ROLE_LIST, []);
            this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
              this.$store.commit(UPDATE_LOADING, false);
            });
          }
        })
        .catch(({ msg }) => {
          this.$store.commit(UPDATE_LOADING, false);
          this.$store.commit(SWITCH_SERVER, 0);
          this.$store.commit(UPDATE_PC_SERVER_ID, 0);
          this.$store.commit(UPDATE_ROLE_LIST, []);
          alert(msg);
        });
    },
    updateUid(id) {
      if (id !== this.uid) {
        let curId = String(id).replace(/[^\d]*/g, '');
        this.$store.dispatch(UPDATE_UID, curId);
      }
    },
    getCurSid(id) {
      let res = id;
      if (!id) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == id) {
          res = this.serverList[i].SID;
          break;
        }
      }
      return res;
    },
    getCurRoleName(id) {
      let res = '';
      if (!this.roleList) return res;
      for (let i in this.roleList) {
        if (this.roleList[i].roleID == id) {
          res = this.roleList[i].roleName;
          break;
        }
      }
      return res;
    },
    loadRole() {
      this.resetStatus();
      this.$store.dispatch(GET_ROLE_LIST, {
        serverId: this.serverId,
        hideLoading: false
      });
      this.$store.commit(UPDATE_PRODUCT_LIST, []);
      this.$store.commit(UPDATE_PRODUCT_TYPES, []);
    },
    initViewport,
    getThirdPartyLogin() {
      this.$store.dispatch(UPDATE_THIRD_LIST);
    },
    showUidLoginPopup() {
      this.$store.commit(UPDATE_IS_JP_UID_LOGIN, true);
      this.$store.commit(UPDATE_IS_LOGIN_POPUP, true);
    },
    hideUidLoginPopup() {
      this.$store.commit(UPDATE_IS_JP_UID_LOGIN, false);
      this.$store.commit(UPDATE_IS_LOGIN_POPUP, false);
    },
    showLoginPopup() {
      this.$store.commit(UPDATE_IS_JP_UID_LOGIN, false);
      this.$store.commit(UPDATE_IS_LOGIN_POPUP, true);
    },
    hideLoginPopup() {
      this.$store.commit(UPDATE_IS_JP_UID_LOGIN, false);
      this.$store.commit(UPDATE_IS_LOGIN_POPUP, false);
    },
    showSelectRolePopup() {
      if (!this.serverList?.length) {
        this.$store.commit(UPDATE_LOADING, true);
        this.$store.dispatch(GET_SERVER_LIST).then(() => {
          this.$store.commit(UPDATE_LOADING, false);
          this.$store.commit(UPDATE_IS_SELECT_ROLE_POPUP, true);
          showPopup(popupType.charPopup);
        });
        return;
      }
      this.$store.commit(UPDATE_IS_SELECT_ROLE_POPUP, true);
      showPopup(popupType.charPopup);
    },
    hideSelectRolePopup() {
      this.$store.commit(UPDATE_IS_SELECT_ROLE_POPUP, false);
    },
    hideSwitchRolePanel() {
      this.$store.commit(UPDATE_SWITCH_ROLE_PANEL, false);
    },
    showSwitchRolePanel() {
      this.$store.commit(UPDATE_SWITCH_ROLE_PANEL, true);
    },
    toggleSwitchRolePanel() {
      this.switchRolePanel
        ? this.hideSwitchRolePanel()
        : this.showSwitchRolePanel();
    },
    setRoleInfo(serverId, serverSid, roleId) {
      this.serverId = serverId;
      this.$store.commit(UPDATE_PC_SERVER_ID, serverSid);
      this.roleId = roleId;
      window.webstorev35DataLayer.push({
        eventName: 'bind',
        eventReason: 'auto_bind'
      });
      window.webstorev35DataLayerBatch?.push({
        eventName: 'bind',
        eventReason: 'auto_bind'
      });
    },
    selectRole(hideLoading) {
      // trackStagePoint('select_role_start');
      let serverId = globalConfig.getHrefParam('server_id') || null;
      //pcServerId 厂商的serverId（简码）。serverId后端的用的server_id（全码）
      let pcServerId = globalConfig.getHrefParam('serverId') || null;
      hideLoading || this.$store.commit(UPDATE_LOADING, true);
      // trackStagePoint('select_role_get_server_list_start');
      this.$store.dispatch(GET_SERVER_LIST).then(serverList => {
        // trackStagePoint('select_role_get_server_list_end');
        hideLoading || this.$store.commit(UPDATE_LOADING, false);
        if (!serverId && pcServerId) {
          serverId = mapServerIdBypcServerId(pcServerId, serverList.history); // 先匹配历史选择过的服务器
          if (serverId === '') {
            serverId = mapServerIdBypcServerId(pcServerId, serverList.all); // 历史中选择过的服务器没有找到才全部搜一遍
          }
        }
        if (this.gameId && serverId) {
          // trackStagePoint('select_role_game_id_and_server_id_exist');
          // 如果是储值页返回的，设置默认伺服器、获取角色列表、更新当前角色
          this.serverId = serverId;
          this.$store
            .dispatch(GET_ROLE_LIST, {
              serverId,
              hideLoading: false
            })
            .then(({ roleId }) => {
              // trackStagePoint('select_role_get_role_list_end');
              this.roleId = roleId;
              this.loadProduct('auto_bind');
            })
            .catch(e => {
              console.error(e);
            });
        } else {
          this.showSelectRolePopup();
        }
      });
    },
    checkRoleExist(serverId, serverSid) {
      // trackStagePoint('check_role_exist_start');
      this.$store
        .dispatch(GET_ROLE_LIST, {
          serverId,
          hideLoading: true
        })
        .then(({ roleId }) => {
          // trackStagePoint('check_role_exist_end');
          if (roleId) {
            this.setRoleInfo(serverId, serverSid, roleId);
            // trackStagePoint('check_role_exist_role_id_exist');
          } else {
            this.selectRole(true);
          }
        });
    },
    loadProduct(selectReason) {
      if (this.roleId && this.roleId !== -1) {
        this.hideSelectRolePopup();
        this.hideSwitchRolePanel();
        this.$store.dispatch(GET_PRODUCT_LIST);
        updateCommonParamsInfo({
          roleId: this.roleId,
          roleName: this.roleName,
          serverId: this.serverId
        });
        window.webstorev35DataLayer.push({
          eventName: 'bind',
          eventReason: selectReason || ''
        });
        window.webstorev35DataLayerBatch?.push({
          eventName: 'bind',
          eventReason: selectReason || ''
        });
      } else {
        this.showSelectRolePopup();
      }
    }
  }
};
